export const config = Object.freeze({
  ...__APP_SETTINGS__,
  version: __APP_VERSION__,
  build: __BUILD_ID__,
});
export const storageKey = (key: string) =>
  `yestv:${config.environment}:v1:${key}`;
